// extracted by mini-css-extract-plugin
module.exports = {"greeWrap":"terms-of-service_greeWrap__3-DVJ","title":"terms-of-service_title__1tFpW","section":"terms-of-service_section__1XstM"};